export const mockUser = {
  id: "u1",
  name: "김민수",
  email: "minsu@email.com",
  phone: "010-1234-5678",
  grade: "일반",
  joinedAt: "2026-02-15",
  avatar: "https://img.echotwin.kr/kangstudy/4bd20c1507c2c5d3.jpg",
};

export const enrollmentHistory = [
  { id: "e1", courseTitle: "경매 입문 클래스", type: "무료", progress: 100, enrolledAt: "2026-02-20", completedAt: "2026-03-05", price: 0 },
  { id: "e2", courseTitle: "권리분석 마스터 과정", type: "유료", progress: 75, enrolledAt: "2026-03-10", completedAt: null, price: 350000 },
  { id: "e3", courseTitle: "입찰가 산정 실전반", type: "유료", progress: 30, enrolledAt: "2026-05-01", completedAt: null, price: 450000 },
  { id: "e4", courseTitle: "오프라인 특강 - 경매현장답사", type: "오프라인", progress: 100, enrolledAt: "2026-04-15", completedAt: "2026-04-16", price: 200000 },
];

export const paymentHistory = [
  { id: "p1", type: "강의", item: "권리분석 마스터 과정", amount: 350000, status: "완료", date: "2026-03-10" },
  { id: "p2", type: "강의", item: "입찰가 산정 실전반", amount: 450000, status: "완료", date: "2026-05-01" },
  { id: "p3", type: "리포트", item: "경매 초보자를 위한 필수 체크리스트", amount: 49000, status: "완료", date: "2026-05-18" },
  { id: "p4", type: "강의", item: "오프라인 특강 - 경매현장답사", amount: 200000, status: "완료", date: "2026-04-15" },
];

export const favoriteItems = [
  {
    id: "f1",
    caseNumber: "2025타경12345",
    court: "서울중앙지방법원",
    location: "서울 강남구 역삼동",
    propertyType: "아파트",
    minimumPrice: 580000000,
    auctionDate: "2026-06-15",
    grade: "A",
    imagePrompt: "modern high rise apartment building exterior in Gangnam Seoul Korea, clean contemporary architecture, bright daylight, warm sophisticated urban tones, premium real estate photography, soft natural lighting, beige and cream color palette",
    imageUrl: "https://img.echotwin.kr/kangstudy/3fa3b27e06fce368.jpg",
  },
  {
    id: "f2",
    caseNumber: "2025타경23456",
    court: "수원지방법원",
    location: "경기 용인시 수지구",
    propertyType: "아파트",
    minimumPrice: 320000000,
    auctionDate: "2026-06-20",
    grade: "B",
    imagePrompt: "modern apartment complex in Yongin Suji Korea, clean residential architecture, bright daylight, warm beige tones, soft natural lighting, premium real estate photography",
    imageUrl: "https://img.echotwin.kr/kangstudy/4ba33692bf90975a.jpg",
  },
  {
    id: "f3",
    caseNumber: "2026타경34567",
    court: "인천지방법원",
    location: "인천 서구 청라동",
    propertyType: "오피스텔",
    minimumPrice: 180000000,
    auctionDate: "2026-07-05",
    grade: "A",
    imagePrompt: "modern officetel building in Cheongna Incheon Korea, clean contemporary design, bright natural daylight, warm cream and beige tones, premium cityscape photography",
    imageUrl: "https://img.echotwin.kr/kangstudy/c527c85fbfed8e32.jpg",
  },
];

export const consultationHistory = [
  { id: "c1", type: "1:1 상담", date: "2026-03-12", time: "오후 3:00 - 4:00", status: "완료", summary: "경매 입문 전반에 대한 상담 진행. 권리분석 기초 교육 추천." },
  { id: "c2", type: "물건분석 상담", date: "2026-04-08", time: "오전 11:00 - 12:00", status: "완료", summary: "서울 강남구 역삼동 아파트 물건 분석. 권리분석 결과 양호, 입찰 추천." },
  { id: "c3", type: "매매사업자 상담", date: "2026-06-10", time: "오후 7:00 - 8:00", status: "예정", summary: "매매사업자 세무 전략 및 자금조달 방안 상담 예정." },
];

export const mypageTabs = [
  { key: "courses", label: "수강내역", icon: "ri-book-open-line" },
  { key: "payments", label: "결제내역", icon: "ri-bank-card-line" },
  { key: "favorites", label: "관심물건", icon: "ri-heart-line" },
  { key: "consultations", label: "상담내역", icon: "ri-customer-service-2-line" },
];